import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import ThemeFlag from './imgs/theme-travel-flag.png';
import styles from './styles.module.scss';
import Tags from '@components/Common/Tags';
import { limitTextLength } from '@utils/utils';
import { I_RecommendList } from '@Redux/detail/Recommend/reducer';
import { removeRecommendAction } from '@Redux/detail/Recommend/actions';
import defaultImg from '@utils/defaultImg';
import cN from 'classnames';
import { useTranslation } from 'react-i18next';

interface I_Props extends I_RecommendList {
    index?: number;
    Route?: string;
    GroupID?: string;
    IsCurrent?: boolean;
    currency?: string;
}

function RecommendCard({
    Airline,
    ImgUrl,
    Price,
    TourDays,
    TourName,
    ProductType,
    index,
    TripTypeList,
    TagList,
    Route,
    IsCurrent,
    Status,
    currency,
}: I_Props) {
    const dispatch = useDispatch();
    const tagsContainerEl = useRef<HTMLDivElement>(null);
    const { t } = useTranslation();

    const removeRecommandCard = (e: React.MouseEvent) => {
        e.stopPropagation();
        dispatch(removeRecommendAction(index!));
    };

    //三位一撇
    function three(num: number | string) {
        const parts = num.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.'); // '$' +
    }

    return TourName ? (
        <div
            className={cN(
                styles.container,
                IsCurrent && styles['is-current'],
                Status === 5 && styles['disabled']
            )}
        >
            <div className={styles['img__frame']}>
                <a href={Route ? Route : '#'} target="_blank" rel="noreferrer noopener">
                    <img
                        className={styles.img}
                        src={ImgUrl || defaultImg}
                        alt={TourName}
                        onError={(e: any) => (e.target.src = defaultImg)}
                        loading="lazy"
                    />
                </a>
            </div>
            <div className={styles['lowest-price']}>
                {Status !== 5 ? (
                    <>
                        <span className={styles['lowest-price__country']}>
                            {currency ? currency : 'TWD'}
                        </span>
                        <span className={styles['lowest-price__number']}>
                            {typeof Price === 'number' ? three(Price) : Price}
                        </span>
                        <span>人/起</span>
                    </>
                ) : (
                    '－－'
                )}
            </div>
            <a
                href={Route ? Route : '#'}
                target="_blank"
                rel="noreferrer noopener"
                className={styles.title}
            >
                {limitTextLength(TourName, 60)}
            </a>
            <div className={styles['tourdays-and-flight']}>
                <span>共{TourDays}天</span>
                <span>{Airline}</span>
            </div>
            <div className={styles.tags}>
                <div ref={tagsContainerEl}>
                    <Tags TripTypeList={TripTypeList!} TagList={TagList!} />
                </div>
            </div>
            <a
                href={Route ? Route : '#'}
                target="_blank"
                rel="noreferrer noopener"
                className={cN(
                    styles.button,
                    IsCurrent && styles['is-current'],
                    Status === 5 && styles['disabled']
                )}
            >
                {Status !== 5 ? (IsCurrent ? '立即報名' : '點看此行程') : t('closeGroup')}
            </a>
            {!IsCurrent && (
                <span
                    className={styles['cancel-button']}
                    onClick={(e: React.MouseEvent) => removeRecommandCard(e)}
                />
            )}
            {ProductType === '1' && <img className={styles.flag} src={ThemeFlag} alt="主題旅遊" />}
        </div>
    ) : (
        <div className={styles['no-data']}>
            {/* <p>
                想探索更多行程
                <br />
                請回到搜尋引擎再次搜尋喔 !
            </p> */}
        </div>
    );
}

export default RecommendCard;
